import App from './App.vue'
import { createApp } from 'vue'
import router from './router'

// https://stackoverflow.com/questions/65513579/how-do-i-turn-off-the-productiontip-warning-in-vue-3
// Vue.config.productionTip = false

// Vue 2
// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')

// Vue 3
const app = createApp(App).use(router)
const sentryDsn = process.env.VUE_APP_SENTRY_DSN?.trim()

async function mountApp() {
  // 共用 build 若沒有 DSN 就不載入 SDK；載入或初始化失敗也不能阻止既有頁面掛載。
  if (sentryDsn) {
    try {
      const Sentry = await import('@sentry/vue')
      Sentry.init({
        app,
        dsn: sentryDsn,
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
        sendDefaultPii: false,
        tracesSampleRate: 0.1,
      })
    } catch (error) {
      console.error('[telemetry] Sentry initialization failed', error)
    }
  }

  app.mount('#app')
}

void mountApp()
